import { graphql, useFragment } from 'react-relay';
import RespondentFilterUsingMetaResults from './RespondentFilterUsingMetaResults';
import type { RespondentFilterUsingMetaResultsProps } from './RespondentFilterUsingMetaResults';
import RespondentFilterUsingMetaGroups from './RespondentFilterUsingMetaGroups';
import type { RespondentFilterUsingMetaGroupsProps } from './RespondentFilterUsingMetaGroups';
import type { RespondentFilter_questionnaire$key } from './__generated__/RespondentFilter_questionnaire.graphql';

const questionnaireFragment = graphql`
    fragment RespondentFilter_questionnaire on QuestionnaireInterface {
        ...RespondentFilterUsingMetaGroups_questionnaire
        ...RespondentFilterUsingMetaResults_questionnaire
    }
`;
export type RespondentFilterProps = {
    questionnaire: RespondentFilter_questionnaire$key;
} & (
    | Omit<RespondentFilterUsingMetaResultsProps, 'classes' | 'questionnaire'>
    | Omit<RespondentFilterUsingMetaGroupsProps, 'classes' | 'questionnaire'>
);
export default function RespondentFilter(props: RespondentFilterProps) {
    const questionnaire = useFragment(
        questionnaireFragment,
        props.questionnaire,
    );
    if ('metaGroups' in props) {
        return (
            <RespondentFilterUsingMetaGroups
                {...props}
                questionnaire={questionnaire}
            />
        );
    }
    return (
        <RespondentFilterUsingMetaResults
            {...props}
            questionnaire={questionnaire}
        />
    );
}
